// extracted by mini-css-extract-plugin
export default {"viewbtn":"View_viewbtn__e34dy"};